<template>
    <ul class="py-4 space-y-2 sm:px-6 sm:space-y-4 lg:px-8">
        <li class="flex justify-between space-x-2" v-for="message in messages">
            <div class="shrink-0">
                <img :src="message.user.avatar_or_default" class="h-10 w-10 rounded-full mr-3" />
            </div>

            <div class="flex-1 bg-white px-4 py-6 shadow sm:rounded-lg sm:px-6">
                <div v-if="message.user.type === 'teacher'" class="mb-3">
                    <img :src="conversation.school_logo" class="mt-3" v-if="conversation.school_logo" />
                </div>
                <div class="sm:flex sm:justify-between sm:items-baseline">
                    <h3 class="text-base font-medium">
                        <span class="text-gray-900">{{ message.user.name_or_nickname }}</span>
                        <span class="pl-1 text-gray-600">{{ $t('messages.wrote') }}</span>
                    </h3>
                    <div class="flex gap-2 items-center">
                        <div v-if="message.can.delete">
                            <DeleteMessageModal :links="message.links"/>
                        </div>
                        <p class="mt-1 text-sm text-gray-600 whitespace-nowrap sm:mt-0 sm:ml-3">
                            <time :datetime="message.created_at">{{ message.diff_for_humans }}</time>
                        </p>
                    </div>
                </div>
                <div class="mt-4 space-y-6 text-gray-800">
                    <p v-html="message.message" class="whitespace-pre-line"></p>
                    <div class="flex justify-end space-x-2 align-center" v-if="isTeacher">
                        <inertia-link
                            :href="message.links.batch_show"
                            :title="$t('messages.group_message')"
                            v-if="message.batch"
                        >
                            <IconSpeakerphone class="w-4 h-4 text-indigo-600" />
                        </inertia-link>
                        <div v-if="message.read_at" class="flex">
                            <span class="text-sm text-gray-600">
                                {{ $t('messages.read_at') }}
                                {{ formatDate(message.read_at) }}
                            </span>
                            <IconChecks class="w-4 h-4 text-blue-600" />
                        </div>
                    </div>
                </div>
                <div v-if="message.image_path">
                    <img :src="message.image_path" class="mt-3" alt="" />
                </div>
                <AppCard v-if="message.attachments.length" class="mt-5">
                    <AttachmentsList :attachments="message.attachments" />
                </AppCard>
                <div v-if="message.user.type === 'teacher'">
                    <img :src="conversation.school_signature" class="mt-3" v-if="conversation.school_signature" />
                </div>
            </div>
        </li>
    </ul>
</template>
<script>
import AppCard from '@/Shared/AppCard.vue';
import AttachmentsList from '@/components/AttachmentsList.vue';
import { IconChecks, IconSpeakerphone } from '@tabler/icons-vue';
import DeleteMessageModal from './DeleteMessageModal.vue';

export default {
    name: 'message-list',
    components: {DeleteMessageModal, IconSpeakerphone, IconChecks, AttachmentsList, AppCard },
    props: {
        messages: {
            type: Array,
        },
        conversation: {
            type: Object,
        },
    },
    data: function () {
        return {
            isTeacher: this.$page.props.auth.user.type === 'teacher',
        };
    },
    methods: {
        formatDate(date) {
            return new Date(date).toLocaleDateString(this.$i18n.locale, {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
            });
        },
    },
};
</script>
